import styled from "styled-components";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";

// v1 stores bold and highlight as <strong>. Both toolbar actions use Lexical's
// "bold" format; emphasis controls whether <strong> is yellow or bold weight.

// Height is driven by the `rows` prop (matches the ONS DS textarea API).
export const EditorContentEditable = styled(ContentEditable)<{
  $rows: number;
  $singleLine: boolean;
  $emphasis?: "bold" | "highlight";
}>`
  outline: none;
  border: 1px solid var(--ons-color-black);
  border-radius: 0 0 4px 4px;
  margin-top: -1px;
  padding: 9px;
  font-size: 1rem;
  line-height: 1.5;
  min-height: ${(properties) => `calc(${properties.$rows} * 1.5rem + 18px)`};

  &:focus-visible {
    outline: 2px solid var(--ons-color-sun-yellow);
  }

  p,
  h2,
  ul,
  ol,
  li {
    margin: 0;
  }

  ${(properties) =>
    properties.$emphasis === "highlight" &&
    `
    strong,
    b {
      background-color: var(--ons-color-sun-yellow);
      color: inherit;
    }
  `}

  ${(properties) =>
    properties.$emphasis === "bold" &&
    `
    strong,
    b {
      font-weight: bold;
    }
  `}

  ${(properties) =>
    properties.$singleLine &&
    `
    min-height: auto;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
  `}
`;
